<template>
  <div>
    <section id="dashboard" v-if="business">
      <div class="container service-board">
        <div class="text-body">
          <b>
            <h2>“НОМИН БИЗНЕС КАРТ”-ИЙН <br />ХЭРЭГЛЭГЧИЙН ГЭРЭЭ</h2>
          </b>
          <div class="between">
            <p>2023 оны ... сарын ...-ны өдөр</p>
            <p>№</p>
            <p>Улаанбаатар хот</p>
          </div>
          <p>
            &nbsp; &nbsp; Нэг талаас Монгол Улс, Улаанбаатар хот, Хан-Уул
            дүүрэг, 20-р хороо, Чингисийн өргөн чөлөө, Номин Юнайтед цогцолборын
            5 давхарт байрлах ”НОМИН Тав Трейд” ХХК-ийн Картын төв, түүнийг
            төлөөлж захирал С.Ганбаяр /цаашид “Картын төв” гэх/, Нөгөө талаас
            .........................................................................................
            хаягт байрлах “...............................” ХХК, түүнийг төлөөлж
            Гүйцэтгэх захирал
            ................................................... /цаашид
            “Байгууллага” гэх, хамтад нь “Талууд” гэх/ нар Монгол Улсын Иргэний
            хууль, холбогдох бусад хууль тогтоомжийг үндэслэн дараах
            нөхцөлүүдийг харилцан тохиролцсоны үндсэн дээр энэхүү “Хэрэглэгчийн
            гэрээ” /цаашид “Гэрээ” гэх/-г байгуулав
          </p>
        </div>

        <div class="text-body">
          <h2>НЭГ. НИЙТЛЭГ ҮНДЭСЛЭЛ</h2>
          <p>
            1.1 Энэхүү гэрээгээр Байгууллага, түүнийг төлөөлөх эрх бүхий карт
            эзэмшигч ажилтан нь “НОМИН БИЗНЕС КАРТ”-ын үйлчилгээний нөхцөлийн
            дагуу карт нээлгэх, картын мэдээлэл, гүйлгээний хуулга харах, өөрийн
            мэдээллийг засах, хадгалах, “НОМИН Бизнес карт”-ыг /цаашид “Карт”
            гэх/ ашиглан бонус оноо цуглуулах, зарцуулахтай холбогдсон бусад
            харилцааг зохицуулна.
          </p>
          <p>
            1.2 Картын төв нь Байгууллагын бичгээр гаргасан хүсэлтийн үндсэн
            дээр Байгууллагын итгэмжлэгдсэн ажилтанд картыг олгоно.
          </p>
          <p>
            1.3 Энэxүү гэрээний хэрэгжилтэд Картын төв болон Байгууллага xамтран
            xяналт тавина.
          </p>
          <p>
            1.4 Карт нь картын төвийн өмч бөгөөд Байгууллага, түүний төлөөлөх
            эрх бүхий ажилтан нь карт эзэмшигч болно..
          </p>
          <p>
            1.5 Байгууллага, түүнийг төлөөлөх эрх бүхий ажилтан нь
            www.bonus.nomin.mn цахим хуудасыг болон Enomin аппликейшнээр
            дамжуулан картын мэдээлэл, гүйлгээний хуулгыг харна
          </p>
          <p>
            1.6 Картын хувь бонус нь www.bonus.nomin.mn цахим хуудас, Enomin
            аппликейшнд байрлах “НОМИН Бонус картын үйл ажиллагааны журам”-д
            зааснаар болон “Ханган нийлүүлэлтийн хэлтэс”-тэй хийсэн гэрээний
            дагуу бодогдож орно.
          </p>
          <p>1.7 Картын бонусыг мөнгөөр олгохгүй болно.</p>
          <p>
            1.8 Картын “Үйлчилгээний нөхцөл”-ийг энэхүү гэрээний Хавсралт №1-ээр
            тохиролцов. Хавсралтууд нь энэхүү гэрээний салшгүй хэсэг байна.
          </p>
        </div>

        <div class="text-body">
          <h2>ХОЁР. БАЙГУУЛЛАГА, КАРТ ЭЗЭМШИГЧИЙН ЭРХ, ҮҮРЭГ</h2>
          <p>
            2.1.Байгууллага нь түүнийг төлөөлөн байгууллагын картыг эзэмших
            ажилтнуудыг /цаашид “Карт эзэмшигч” гэх/ томилно.
          </p>
          <p>
            2.2 Номин бизнес карт эзэмшигч нь тухайн байгууллагын эрх бүхий
            удирдлагын томилсон 3 хүртэлх итгэмжлэгдсэн ажилтан байж болох ба
            карт эзэмшигч нь картаар бонус оноо хуримтлуулах болон зарцуулалт
            хийх эрхтэй.
          </p>
          <p>
            2.3 Карт эзэмшигч нь шинээр карт хүлээн авахдаа компаниас өгсөн нууц
            кодыг нууцлах үүрэгтэй ба бусдад картаа дамжуулан хэрэглүүлэхийг
            хориглоно.
          </p>
          <p>
            2.4 Kарт эзэмшигч нь гар утас, эсхүл картыг гээсэн, үрэгдүүлсэн,
            xулгайд алдсан тоxиолдолд 1800-2888 лавлах утсанд холбогдон бонусаа
            зарцуулах эрхийг түр хаалгаж, бусдад зүй бусаар ашиглуулахаас
            сэргийлэх үүрэгтэй.
          </p>
          <p>
            2.5 Kарт эзэмшигч нь өөрийн мэдээллийн аюулгүй байдлыг бүрэн xангаx
            үүрэгтэй бөгөөд картын нууц үг, картын төвд бүртгэлтэй утасны
            дугаарыг бусдад шилжүүлэх, ашиглуулахыг хориглоно.
          </p>
          <p>
            2.6 Энэхүү гэрээний 2.3-2.5-д заасан үүргийг Байгууллага болон Карт
            эзэмшигч биелүүлээгүй, зохих ёсоор биелүүлээгүйн улмаас үүсэх
            эрсдэлийг Картын төв хариуцахгүй.
          </p>
          <p>
            2.7 Байгууллагын картыг карт эзэмшигч өөрийн хувийн худалдан авалтад
            ашиглах болон өөр бусад иргэнд дамжуулах замаар тухайн байгууллагад
            хохирол учруулсан тохиолдолд байгууллага Картын төвд хандан картыг
            идэвхигүй болгох, карт эзэмшигчийг солих буюу хасуулах боломжтой ба
            байгууллагад учирсан хохирлыг Картын төв хариуцахгүй.
          </p>
          <p>
            2.8 Байгууллага нь
            <b>ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ, ХЭРЭГЛЭГЧИЙН ГЭРЭЭГ УНШИЖ ТАНИЛЦАН ХҮЛЭЭН
              ЗӨВШӨӨРСӨН БОЛНО.</b>
          </p>
        </div>

        <div class="text-body">
          <h2>ГУРАВ. КАРТЫН ТӨВИЙН ЭРХ, ҮҮРЭГ</h2>
          <p>
            3.1 “НОМИН Холдинг” ХХК-ийн нэгдэлд хамаарах хуулийн этгээдүүд,
            болон тэдгээрийн салбар дэлгүүрүүдээс худалдан авсан барааны дүнд
            ногдох бонусыг картын дүрмийн дагуу карт эзэмшигчийн дансанд
            шилжүүлнэ.
          </p>
          <p>
            3.2 “НОМИН Xолдинг” XXK, түүний нэгдэлд хамаарах компаниудаас
            зарласан урамшуулал хөнгөлөлтийн нөхцөлтэй холбоотой үнэн зөв
            мэдээллээр карт эзэмшигчийг хангана.
          </p>
          <p>
            3.3 Бараа буцаалт болон “НОМИН Xолдинг” XXK, түүний нэгдэлд хамаарах
            компаниудаас зарласан бусад төрлийн хөнгөлөлтийг Байгууллага нь
            эдлэх эрхгүй байсан нь тогтоогдсон, давхардсан бол карт эзэмшигчийн
            дансанд орсон бонусыг буцаан байгууллагад мэдэгдэн татах эрхтэй.
            Хэрэв буцаалт хийгдэх үед карт эзэмшигч бонусаа ашигласан буюу карт
            эзэмшигчийн бонус картын үлдэгдэл буцаалт хийх бонусын дүнд хүрэхгүй
            тохиолдолд карт эзэмшигчээр бэлнээр төлүүлнэ.
          </p>
          <p>
            3.4 Гэнэтийн болон давагдашгүй хүчин зүйлсийн улмаас цахилгаан эрчим
            хүч, сүлжээний саатлаас шалтгаалан картаар үйлчлэх боломжгүй нөхцөл
            байдал үүссэн тохиолдолд уншигдаагүй бонусыг нөхөн олгохгүй, мөн
            худалдан авалтын дүн нь нэмэгдэхгүй. Цахилгаан эрчим хүч болон
            сүлжээний саатал нь түр зуурын шалтгаантай саатлаас үүсэн бонус
            нэмэгдээгүй тохиолдлыг карт эзэмшигчийн тухайн салбар нэгжид
            гаргасан хүсэлтийг үндэслэн нөхөж олгож болно.
          </p>
          <p>
            3.5 НОМИН бизнес картаар хувь иргэний худалдан авч буй бараа,
            үйлчилгээний үнийг хөнгөлсөн, бусдын картаар хөнгөлөлт эдлэхийг
            завдсан тохиолдолд картыг хурааж хүчингүй болгох ба бусдын бонусыг
            ашигласан зөрчлийг нөхөн төлүүлэх эрхтэй.
          </p>
          <p>
            3.7 Хувь хүний картыг байгууллагын худалдан авалтанд ашиглаж бонус
            нэмүүлсэн бол тухайн байгууллагын хүсэлтийн дагуу тухайн бонус карт
            ашигласан хэрэглэгчийг идэвхигүй болгох үүрэгтэй.
          </p>
          <p>
            3.8 Эрх бүхий хууль хяналтын байгууллагын албан ёсны шаардлагаар
            гэмт хэрэг, зөрчил шалган шийдвэрлэх ажиллагааны явцад хууль
            сахиулах болон шүүх эрх мэдлийн байгууллагаас албан ёсоор карт
            эзэмшигчийн мэдээллийг шаардсан тохиолдолд зохих мэдээллийг өгнө.
          </p>
        </div>
        <div class="footer-text">
          <div class="row">
            <div class="col-md-6">
              <p>Картын төвийг төлөөлж:</p>
              <p>“Номин Тав Трейд” ХХК-ий Картын төв</p>
              <!-- <p>Нэр: Б.Гэрэлтуяа</p>
              <p>Албан тушаал: Картын төвийн дарга</p>
              <p>Гарын үсэг:</p>
              <div class="imgDev">
                <img
                  src="@/assets/Picture1.png"
                  alt=""
                  style="margin-right: 10px"
                />
              </div> -->
            </div>
            <div class="col-md-6">
              <p>Байгууллагыг төлөөлж:</p>
              <p>“................................” ХХК</p>
              <p>Нэр: {{ this.lastName + " " + this.firstName }}</p>
              <p>Албан тушаал:</p>
              <p>Гарын үсэг:</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"></div>
          <div class="col-md-6">
            <p></p>
            <p class="padding">
              ........... тоот “НОМИН Бизнес Карт”-ын Хэрэглэгчийн гэрээний
              Хавсралт №1
            </p>
          </div>
        </div>
        <div class="text-body">
          <h2>ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</h2>
          <p>
            1. НОМИН БИЗНЕС КАРТ нь Аж ахуйн нэгжид зориулсан Хөнгөлөлтийн карт
            бөгөөд карт нь “Бизнес бонус халаас” /Business bonus pocket/,
            “Бизнес гишүүнчлэлийн халаас” /Business membership pocket/ гэсэн
            хоёр халаасыг нэг картан дээр агуулсан бүтээгдэхүүн юм. НОМИН БИЗНЕС
            КАРТ нь дараах төрөлтэй байна. Үүнд:
          </p>
          <p>
            &nbsp; &nbsp; 1.1.Бизнес бонус карт: 1%-10% хүртэл хувь өсдөг
            худалдан авалт бүрээс бонус зарцуулж, цуглуулах, үйлчилгээний үнийн
            дүнгийн 50 хүртэлх хувьд зарцуулан хөнгөлөлт эдлэх боломжтой.
          </p>
          <p>
            &nbsp; &nbsp; 1.2.Бизнес гишүүнчлэлийн карт: Номин бизнес клуб буюу
            Улаанбаатар импекс салбараас хийсэн худалдан авалт бүрээсээ 2%-ийн
            бонус цуглуулах боломжтой бөгөөд цуглуулсан бонусаа улиралдаа 1 удаа
            худалдан авалтандаа 100 хувь ашиглах боломжтой.
          </p>
          <p>
            2. Байгууллага нь энэхүү гэрээгээр “НОМИН Xолдинг” XXK, түүний
            нэгдэлд хамаарах компаниудад Байгууллага болон түүнийг төлөөлөх эрх
            бүхий карт эзэмшигчийн хуулиар зөвшөөрөгдсөн мэдээллийг цуглуулаx,
            боловсруулаx, ашиглаx, дамжуулаx зөвшөөрлийг олгож байгаа болно
          </p>
          <p>
            3. Kарт эзэмшигч нь www.bonus.nomin.mn, Еnomin аппликейшнд
            нэвтэрснээр Бонус оноо цуглуулах, зарцуулах, гүйлгээний хуулга
            харах, үлдэгдэл оноо шалгах, урамшуулалт хөтөлбөрүүдэд хамрагдах,
            бүтээгдэхүүн үйлчилгээний талаар мэдээлэл авах боломжтой болно.
          </p>
          <p>
            4. Kарт эзэмшигч нь бонус оноо цуглуулах, зарцуулахдаа пин код /4
            оронтой тоо/ ашиглана. www.bonus.nomin.mn, Enomin аппликейшн-ээр
            нэвтрэн гүйлгээний пин кодоо өөрчлөх боломжтой.
          </p>
          <p>
            5. Kарт эзэмшигч нь “НОМИН Холдинг” ХХК-ийн нэгдэлд хамаарах хуулийн
            этгээдүүд, болон тэдгээрийн салбар дэлгүүрүүдээс худалдан авалт хийх
            үедээ 1 бонус оноо =1 төгрөг зарчмаар бонус оноогоор бүтээгдэхүүн,
            үйлчилгээг авна.
          </p>
        </div>
        <div class="footer-text">
          <div class="row">
            <div class="col-md-6">
              <p>Картын төвийг төлөөлж:</p>
              <p>“Номин Тав Трейд” ХХК-ий Картын төв</p>
              <!-- <p>Нэр: Б.Гэрэлтуяа</p>
              <p>Албан тушаал: Картын төвийн дарга</p>
              <p>Гарын үсэг:</p>
              <div class="imgDev">
                <img
                  src="@/assets/Picture1.png"
                  alt=""
                  style="margin-right: 10px"
                />
              </div> -->
            </div>
            <div class="col-md-6">
              <p>Байгууллагыг төлөөлж:</p>
              <p>“................................” ХХК</p>
              <p>Нэр: {{ this.lastName + " " + this.firstName }}</p>
              <p>Албан тушаал:</p>
              <p>Гарын үсэг:</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="dashboard" v-else>
      <div class="container service-board">
        <div class="text-body">
          <h2>“НОМИН БОНУС ЛОЯАЛТИ ХӨТӨЛБӨР”-ИЙН ХЭРЭГЛЭГЧИЙН ГЭРЭЭ</h2>
        </div>

        <div class="text-body">
          <p>
            <b>Ерөнxий заалт:</b> “НОМИН БОНУС ЛОЯАЛТИ ХӨТӨЛБӨР”-ийн үйлчилгээний нөхцөлийн дагуу карт эзэмшигч нь
            card.nomin.mn цахим хуудсыг ашиглан бонус карт нээлгэх, bonus.nomin.mn цахим хуудас болон Nomin
            аппликейшнаар дамжуулан картын мэдээлэл харах, засах, хамтран эзэмшигч нэмэх, хасах, өөрийн болон хамтран
            эзэмшигчийн гүйлгээний хуулга харах, бонус шилжүүлэг хийхтэй холбоотой үүсэх харилцааг зохицуулахад оршино.
          </p>
          <h2>НЭГ. ГЭРЭЭНИЙ ЗҮЙЛ</h2>
          <p>
            1.1 Энэxүү үйлчилгээний нөxцөлийн хэрэгжилтэд “Номин Тав Трейд” XXK-ийн Картын төв /цаашид “Компани” гэx/
            болон карт эзэмшигч xамтран хяналт тавина.
          </p>
          <p>
            1.2 Компани нь хэрэглэгчийн хүсэлтээр бонус карт /цаашид "карт" гэх/ олгох, үйлчилгээ үзүүлэх, картаа
            ашиглан бонус оноо цуглуулах, зарцуулахтай холбогдон үүсэх талуудын эрх, үүрэг, хариуцлагыг тодорхойлох
            харилцааг зохицуулахад уг гэрээний зорилго оршино.
          </p>
          <p>
            1.3 Карт нь компанийн өмч бөгөөд картын хувь болон бонус нь Картын төвийн үйл ажиллагааны журамд зааснаар
            бодогдож орно.
          </p>
          <p>1.4 Картын бонусыг мөнгөөр олгохгүй болно.</p>
        </div>

        <div class="text-body">
          <h2>ХОЁР. ҮЙЛЧИЛГЭЭНИЙ НӨХЦӨЛ</h2>
          <p>
            2.1 Карт эзэмшигч нь бонус картыг Номингийн аль ч салбар дэлгүүрт өөрийн биеэр очиж нээлгэх эсхүл
            card.nomin.mn, nomin аппликейшн ашиглан бүртгүүлж үйлчилгээ авах бөгөөд “Номин Тав Трейд” ХХК-ийн толгой
            компани болох “Номин Xолдинг” XXK, түүний нэгдэлд хамаарах компаниудад карт эзэмшигчийн шаардлагатай
            мэдээллийг цуглуулаx, боловсруулаx, ашиглаx, дамжуулаxыг зөвшөөрсний үндсэн дээр гэрээ байгуулагдана.
          </p>
          <p>
            2.2 Карт эзэмшигчийн сүүлийн 2 жилийн худалдан авалтын дүнгээр картын хувь тодорхойлогдож, 3-10% хүртэл өсөж
            буурах бөгөөд картын хувь тооцох интервалыг эдийн засгийн өсөлт, инфляцын түвшинтэй уялдуулан бонус картын 
            журмын дагуу шинэчлэн тогтооно.
          </p>
          <p>
            2.3 “Юнайтед Аллианс” ХХК-тай хамтын ажиллагааны дагуу карт эзэмшигчийн хүсэлтээр Ю-Пойнт карт ашиглах
            боломжийг нээж өгөх бөгөөд, Ю-Пойнт оноо ашиглаж байгаа үед “Юнайтед Аллианс” ХХК-ийн хэрэглэгчтэй
            байгуулсан гэрээний дагуу үйл ажиллагааг хөтөлнө. Карт эзэмшигч нь Ю-Пойнт картыг Номин Бонус карттай
            холбосон бол бонус картын нийт хувиас 3%-ир Ю-Пойнт оноо олгоно.
          </p>
          <p>
            2.4 Kарт эзэмшигч нь Nomin аппликейшнд нэвтэрснээр картын мэдээлэл харах, засах, хамтран эзэмшигч нэмэх,
            хасах, өөрийн болон хамтран эзэмшигчийн гүйлгээний хуулга харах, бонус оноогоо цуглуулах, зарцуулах,
            шилжүүлэх, үлдэгдэл оноогоо шалгах, урамшуулалт хөтөлбөрүүдэд хамрагдах, бүтээгдэхүүн үйлчилгээний талаар
            мэдээлэл авах, санал хүсэлтээ илгээх боломжтой болно.
          </p>
          <p>
            2.5 Kарт эзэмшигч нь бонус оноогоо цуглуулах, зарцуулахдаа пин код /4 оронтой тоо/ ашиглана. bonus.nomin.mn,
            nomin аппликейшн-аар нэвтрэн гүйлгээний пин кодоо өөрчлөх боломжтой.
          </p>
          <p>
            2.6 Kарт эзэмшигч нь Номингийн салбар дэлгүүрүүд болон “Номин холдинг” ХХК-ийн нэгдэлд хамаарах хуулийн
            этгээдээс худалдан авалт хийх үедээ үнийн дүнгийн 50% хүртэлх дүнд 1 бонус оноо = 1 төгрөг зарчмаар бонус
            оноогоо зарцуулан хөнгөлөлт эдлэх боломжтой.
          </p>
          <p>
            2.7 Компани нь карт эзэмшигчдэд хөнгөлөлт, урамшуулал, нэмэлт үйлчилгээ үзүүлсний төлбөрийг сар бүр карт
            эзэмшигчдийн данснаас суутгана. Карт эзэмшигчийн дансны үлдэгдэл хүрэлцэхгүй тохиолдолд тухайн сардаа
            шимтгэлийн дүнд хүртэл үлдэгдэл бонусыг давтан суутгал хийнэ.
          <ul>
            <li>
              Номин бонус 3%-тай хэрэглэгчээс 600 бонус /Юпойнттой нэгдээгүй Номин бонус 3%-тай карт хэрэглэгч нараас
            </li>
            <li>
              Номин бонус 4%-тай хэрэглэгчээс 1200
            </li>
            <li>
              Номин бонус 5%-тай хэрэглэгчээс 1500
            </li>
            <li>
              Номин бонус 6%-тай хэрэглэгчээс 1800
            </li>
            <li>
              Номин бонус 7%-тай хэрэглэгчээс 2100
            </li>
            <li>
              Номин бонус 8%-тай хэрэглэгчээс 2400
            </li>
            <li>
              Номин бонус 9%-тай хэрэглэгчээс 2700
            </li>
            <li>
              Номин бонус 10%-тай хэрэглэгчээс 3000
            </li>
          </ul>
          </p>
          <p>
            2.8 НОМИН бонус карт 3 хувиас 10 хувь хүртэл оноо хуримтлуулах боломжтой карт. Картын хувийг хэрэглэгчийн
            сүүлийн 2 жил буюу 730 хоногийн худалдан авалтын дүнгээр тооцно.
          </p>
          <p>2.9 НОМИН бонус, U-point оноо,барааны бонус, ваучер, купон ашиглах нөхцөл.</p>
          <p>2.9.1 Барааны бонустай үед барааны үнээс барааны бонус, ашигласан НОМИН бонус болон ашигласан U-point оноог
            хасаж үлдэгдэл бэлэн төлсөн дүнгээс картын хувиар НОМИН бонус болон U-point оноог тооцон олгоно.</p>
          <p>2.9.2 Бонус хасагдах дараалал нь:
            <br>&nbsp;&nbsp; 1. U-point оноо
            <br>&nbsp;&nbsp; 2. Барааны бонус
            <br>&nbsp;&nbsp; 3. НОМИН бонус гэсэн дарааллаар хасагдана.
          </p>
          <p>
            2.10 Бөөний болон багцын худалдан авалт хийхээс бусад худалдан авалт дээр бонус оноо нэмэгдэнэ.
          </p>
          <p>2.11 Компани 5-аас дээш жил ашиглаагүй картыг жилд нэг удаа нэгдсэн байдлаар идэвхгүй болгоно.</p>
          <p>2.12 НОМИН бонус карт эзэмшигч нь Финтек буюу BNPL / 3-6 хуваан төлөх / нөхцөлөөр “НОМИН Холдинг” ХХК,
            түүний нэгдэлд хамаарах хуулийн этгээдүүдээс бараа бүтээгдэхүүн худалдан авсан тохиолдолд картын хувийн
            50%-д бонус олгоно.</p>
          <p>2.13 НОМИН аппликейшн болон биет бонус карт ашиглах боломжгүй үед хэрэглэгчийг нэг удаагийн тан кодоор
            баталгаажуулах ба данснаас 49₮-ийг суутгана.</p>
          <!-- <p>2.12.1 Карт эзэмшигч Зээлийн гэрээнд заасан хугацаанд зээл болон хүүгийн төлбөрийг төлөөгүй тохиолдолд,
            хугацаа хэтэрсэн 31 дэх өдрөөс карт эзэмшигчийн нэр дээр бүртгэлтэй Номин бонус карт блоклогдож, зөвхөн
            бонус оноо хуримтлагдах ба зарцуулах боломжгүй болно.</p> -->
          <p>2.14 Карт эзэмшигчдэд хөнгөлөлт, урамшуулал, нэмэлт үйлчилгээ үзүүлсний төлбөрийг бонус онооны үлдэгдлээс
            суутгана. Үндсэн бонусын үлдэгдэл хүрэлцэхгүй тохиолдолд журмын бонусаас суутгана.</p>
          <!-- <p>2.14 Карт эзэмшигчдэд хөнгөлөлт, урамшуулал, нэмэлт үйлчилгээ үзүүлсний төлбөрийг Картын төвөөс шинэчлэн
            тогтоох бөгөөд үйлчилгээний төлбөрийг bonus.nomin.mn сайт дээр байршуулсанаар дагаж мөрдөнө. </p>
          <p>2.15 Карт эзэмшигч нас барсан тохиолдолд түүний гэр бүлийн гишүүний бичгээр гаргасан хүсэлт болон гэр
            бүлийн гишүүн болохыг баталсан баримт бичигт үндэслэн бүртгэлийг солих буюу өвлүүлнэ. </p>
          <p>2.16 Карт эзэмшигч бонус карттай холбоотой гомдол санал хүсэлтийг “НОМИН Холдинг”ХХК-ийн хэрэглэгчтэй
            холбогдох төв 1800-2888 дугаарт холбогдож гаргана. </p> -->
          <p>2.15 Карт эзэмшигч нь “Номин Тав Трейд” ХХК-тай хамаарал бүхий “НОМИН Юнити” ББСБ-аас “OmniWay”
            аппликэйшнээр дамжуулан авсан финтек зээлийн гэрээний үүргээ биелүүлээгүй тохиолдолд Номин бонус карт
            эзэмших, ашиглах, захиран зарцуулах нөхцөлд дараах хязгаарлалт тавигдахыг үүгээр хүлээн зөвшөөрөв. Үүнд:
            <br>&nbsp;&nbsp; 2.15.1 Карт эзэмшигч Зээлийн гэрээнд заасан хугацаанд зээл болон хүүгийн төлбөрийг төлөөгүй
            тохиолдолд, хугацаа хэтэрсэн 31 дэх өдрөөс карт эзэмшигчийн нэр дээр бүртгэлтэй Номин бонус карт блоклогдож,
            зөвхөн бонус оноо хуримтлагдах ба зарцуулах боломжгүй болно.
            <br>&nbsp;&nbsp; 2.15.2 Карт эзэмшигч нь Зээлийн гэрээний үүргээ үл биелүүлж, зээлийн төлбөрийг 90 хоногоос
            дээш хугацаагаар төлөөгүй тохиолдолд карт эзэмшигчийн нэр дээр бүртгэлтэй Номин бонус картад хуримтлагдсан
            оноог компани суутган авах эрхтэй.
            <!-- <br>&nbsp;&nbsp; 2.17.3 Дэд карт эзэмшигч нэмэх тохиолдолд зарцуулах эрхтэй буюу веб, аппликейшнаар
            мэдээллээ бүрэн баталгаажуулсан хэрэглэгчийг нэмэх боломжтой байна;
            <br>&nbsp;&nbsp; 2.17.4 Үндсэн болон хамтран карт эзэмшигч нар өөрсдийн хүсэлтээр данс салгах хүсэлтийг
            салбарын бүртгэлийн ажилтанд хандаж гаргаснаар дансаа салгаж болно.
            <br>&nbsp;&nbsp; 2.17.5 Данс салгах тохиолдолд тус тусын картаар хийсэн худалдан авалт болон бонусын
            үлдэгдлийг салгана. Данс салгах явцад аль нэг карт эзэмшигчийн картын бонусын үлдэгдэл хасах болсон
            тохиолдолд нөгөө картын бонусын үлдэгдлээс хасаж тооцно; -->
          </p>
          <!-- <p>
            2.18 Номин бонус карт эзэмшигч бонус оноог шилжүүлэх боломжтой ба шилжүүлгийн үйлчилгээний шимтгэл нь
            шилжүүлж байгаа бонус онооны 10% байна. Шимтгэлийг илгээж буй карт эзэмшигчийн данснаас суутгана.
            <br>&nbsp;&nbsp; 2.18.1 Андуурагдсан шилжүүлгийн үйлчилгээг буцаах боломжгүй байна.
            <br>&nbsp;&nbsp; 2.18.2 Шилжүүлгийн үйлчилгээг өдөрт 3 хүртэл удаа ашиглах боломжтой.
            <br>&nbsp;&nbsp; 2.18.3 Шилжүүлэх боломжтой дээд дүн 500,000, Шилжүүлэх боломжтой доод дүн 1,000 НОМИН бонус
            оноо байна.
          </p>
          <p>
            2.19 Карт эзэмшигчийн хувийн мэдээллийг бусад этгээдэд задруулахгүй
            байх үүрэг хүлээх хэдий ч хууль, тогтоомж болон гэрээнд заасан
            үндэслэлээр эрх бүхий байгууллага болон хэрэглэгчид үзүүлэх
            үйлчилгээг сайжруулахтай холбоотой гуравдагч этгээдэд дамжуулж
            болно.
          </p>
          <p>
            2.20 Карт эзэмшигчдийн мэдээллийг НОМИН Лояалти системд хадгалж, системийн аюулгүй байдлыг мэдээллийн
            технологийн журмын дагуу Мэдээллийн технологийн салбарын Систем удирдлагын алба хариуцна
          </p> -->
        </div>

        <div class="text-body">
          <h2>ГУРАВ. КАРТ ЭЗЭМШИГЧИЙН ЭРХ ҮҮРЭГ</h2>
          <p>
            3.1 Карт эзэмшигч нь “НОМИН бонус лояалти хөтөлбөрийн гэрээ”-н дагуу үйлчилгээ авах эрхтэй.
          </p>
          <p>
            3.2 Карт эзэмшигч нь “Гүйлгээний пин код” болон онлайн системүүдэд нэвтрэх “Нэвтрэх нууц үг”-н нууцлалыг
            хамгаалах үүрэгтэй. Хэрэглэгч хувийн мэдээллийн нууцлалыг алдсанаас үүсэх хохирлыг компани хариуцахгүй.
          </p>
          <p>
            3.3 Шинээр карт эзэмшигч болсон хэрэглэгч bonus.nomin.mn вэб сайт руу гүйлгээний пин кодоор нэвтрэн нэвтрэх
            нууц кодыг өөрчлөх, гэрээг хүлээн зөвшөөрөх үүрэгтэй.
          </p>
          <p>
            3.4 Үйлчилгээний нөхцөл, түүний нэмэлт өөрчлөлт болон картын хувийн өөрчлөлтийн талаарх мэдээлэл, дансны
            хуулгаа bonus.nomin.mn вэб сайтаар хандан танилцаж, хяналт тавьж байх үүрэгтэй.
          </p>
          <p>
            3.5 Картаа гээсэн, хулгайд алдсан тохиолдолд нэн даруй 1800-2888 тусгай дугаарт өөрийн бүртгэлтэй ID
            дугаараас холбогдож компанийн картын төвд мэдэгдэж, идэвхгүй болгуулах үүрэгтэй ба картыг идэвхгүй
            болгоогүйгээс үүссэн хохирлыг карт эзэмшигч өөрөө бүрэн хариуцна.
          </p>
          <p>
            3.6 Үндсэн карт эзэмшигч нь өөрийн дансанд дахь бонус, хамтран эзэмшигчдийн төлбөр, тооцоог бүрэн хариуцаж,
            хянах үүрэгтэй.
          </p>
          <p>
            3.7 Карт эзэмшигчийн хувийн мэдээлэл, таних мэдээлэлд өөрчлөлт орсон тохиолдолд bonus.nomin.mn веб сайт
            эсвэл өөрийн биеэр бичиг баримттайгаа карт бүртгэлийн ажилтанд хандан мэдээллээ шинэчлэх үүрэгтэй.
          </p>
          <p>
            3.8 “НОМИН Холдинг” ХХК түүний нэгдэлд багтах хуулийн этгээдүүд, НОМИН картын системд холбогдсон бусад
            компани, аж ахуйн нэгж мөн U-point хөтөлбөрт нэгдсэн байгууллагуудаар үйлчлүүлэгч, үйлчлүүлэхийг хүсэгч
            иргэн, байгууллага нь U-point болон НОМИН карт эзэмших эрхтэй.
          </p>
          <p>
            3.9 Карт эзэмшигчээр бүртгүүлэхдээ “НОМИН лояалти хөтөлбөрийн гэрээ”-г хүлээн зөвшөөрөх ба өөрийн хүсэлтээр
            үйлчилгээнээс татгалзах эрхтэй.
          </p>
          <p>
            3.10 Карт эзэмшигч нь НОМИН бонус картыг биет болон цахим хэлбэрээр эзэмших боломжтой.
          </p>
          <p>
            3.11 Карт эзэмшигч нь “НОМИН Юнити” ББСБ-аас “OmniWay” аппликэйшнээр дамжуулан финтек зээл авсан тохиолдолд
            зээлийн гэрээнд заасан хугацааны дагуу үндсэн зээл болон зээлийн хүүгийн төлбөрийг бүрэн төлөх үүрэгтэй ба
            энэ үүргээ биелүүлээгүй тохиолдолд энэхүү гэрээнд заасан нөхцөлийн дагуу Номин бонус карт эзэмших, ашиглах,
            захиран зарцуулах эрх хязгаарлагдана.
          </p>
          <!-- <p>
            3.12 Бараа буцаалт болон компанийн нэгдэлд хамаарах компаниудаас зарласан бусад төрлийн хөнгөлөлттэй давхар
            хөнгөлөлт үзүүлж давхардсан бол, эсхүл системийн алдаанаас үүдэн орох ёсгүй бонус оноо карт эзэмшигчийн
            дансанд орсон тохиолдолд бонусыг буцаан өгөх үүрэгтэй.
          </p>
          <p>
            3.13 Хэрэв буцаалт хийгдэх үед карт эзэмшигч бонусаа ашигласан буюу
            карт эзэмшигчийн бонус картын үлдэгдэл буцаалт хийх бонусын дүнд
            хүрэхгүй тохиолдолд карт эзэмшигчээр бэлнээр төлөх үүрэгтэй.
          </p>
          <p>
            3.14 Карт эзэмшигч Номингийн бүх салбаруудаас зохион байгуулж буй цаг үеийн бонус карттай холбоотой
            хөнгөлөлт урамшуулал, идэвхжүүлэлтэд хамрагдах бол онлайн болон оффлайнд бүртгэлтэй бонус картаар дамжуулан
            хамрагдах үүрэгтэй.
          </p> -->
        </div>

        <div class="text-body">
          <h2>ДӨРӨВ. КОМПАНИЙ ЭРХ ҮҮРЭГ</h2>
          <p>
            4.1 Компаниас худалдан авсан барааны дүнд ногдох бонусыг картын дүрмийн дагуу карт эзэмшигчийн дансанд
            шилжүүлж байх үүрэгтэй.
          </p>
          <p>
            4.2 “Номин Тав Трейд” ХХК-ийн толгой компани болох “Номин Xолдинг” XXK, түүний нэгдэлд хамаарах компаниудаас
            зарласан урамшуулал хөнгөлөлтийн нөхцөлтэй холбоотой үнэн зөв мэдээллээр карт эзэмшигчийг хангана.
          </p>
          <p>
            4.3 Бараа буцаалт болон компанийн нэгдэлд хамаарах компаниудаас зарласан бусад төрлийн хөнгөлөлттэй давхар
            хөнгөлөлт үзүүлэх ёсгүй байсан нь тогтоогдсон, давхардсан бол карт эзэмшигчийн дансанд орсон тохиолдолд
            бонусыг буцаан авах эрхтэй. Хэрэв буцаалт хийгдэх үед карт эзэмшигч бонусаа ашигласан буюу карт эзэмшигчийн
            бонус картын үлдэгдэл буцаалт хийх бонусын дүнд хүрэхгүй тохиолдолд карт эзэмшигчээр бэлнээр төлүүлнэ.
          </p>
          <p>
            4.4 Компанийн үйл ажиллагаанаас үл шалтгаалах гэнэтийн болон давагдашгүй хүчин зүйлийн улмаас цахилгаан
            эрчим хүч, программ хангамж, сүлжээний саатлаас шалтгаалан картаар үйлчлэх боломжгүй нөхцөл байдал үүссэн
            тохиолдолд бонусыг нөхөн олгохгүй мөн худалдан авалтын дүнг нэмэхгүй байх эрхтэй.
          </p>
          <p>
            4.5 Картын төвийн дарга болон менежерүүд карттай гүйлгээ, карт эзэмшигчтэй холбоотой шаардлагатай мэдээллийг
            зөвхөн дотооддоо ашиглах эрхтэй.
          </p>
          <p>
            4.6 “НОМИН бонус болон Юпойнт хөтөлбөр”-т нэгдсэн гишүүн байгууллагуудаар үйлчлүүлэх боломжийг нэмэгдүүлэх,
            гишүүн байгууллагуудын бүтээгдэхүүн, үйлчилгээг сайжруулах, хөгжүүлэлт хийх, хэрэглэгчид урамшуулал санал
            болгох зорилгоор гишүүн байгууллагуудад хэрэглэгчийн өөрийн зөвшөөрлөөр мэдээллийг дамжуулж болно.
          </p>
          <p>
            4.7 Гэмт хэрэг, зөрчил шалган шийдвэрлэх ажиллагааны явцад хууль сахиулах болон шүүх эрх мэдлийн
            байгууллагаас албан ёсоор шаардсан тохиолдолд карт эзэмшигчийн мэдээлэл, бүтээгдэхүүн үйлчилгээ, хөнгөлөлт,
            урамшууллын түүхийн талаарх мэдээллийг өгч болно.
          </p>
        </div>

        <div class="text-body">
          <h2>
            “НОМИН БОНУС ЛОЯАЛТИ ХӨТӨЛБӨР”-ИЙН НӨХЦӨЛ, ХЭРЭГЛЭГЧИЙН ГЭРЭЭГ УНШИЖ
            ТАНИЛЦАН ХҮЛЭЭН ЗӨВШӨӨРЧ БАЙНА.
          </h2>
        </div>
        <div class="footer-text">
          <div class="row">
            <div class="col-md-6">
              <p>“Номин Тав Трейд” ХХК-ий Картын төв</p>
              <p>Нэр:Э.Тамир</p>
              <p>Албан тушаал: Картын төвийн дарга</p>
              <p>Гарын үсэг:</p>
              <div class="imgDev">
                <img src="@/assets/Picture2.png" alt="" style="margin-right: 10px" />
              </div>
            </div>
            <div class="col-md-6">
              <p>
                Үйлчилгээг xүлээн зөвшөөрсөн: <i class="fa fa-check-circle"></i>
              </p>
              <p>Нэр: {{ this.lastName + " " + this.firstName }}</p>
              <p>Гарын үсэг:</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { Service } from "@/mixins/Service";
import EventBus from "@/EventBus.js";
export default {
  data() {
    return {
      serviceData: {},
      lastName: "",
      firstName: "",
      business: false,
    };
  },
  mixins: [Service],
  methods: {
    fetchData() {
      var tokenId = localStorage.getItem("authToken");
      var user = this.$auth.getMe();
      if (tokenId == null || user == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
        return;
      }
      this.$bonusApi
        // this.$axiosApi
        .post(
          `bonus-card/info/token`,
          // `card/info`,
          { tokenId },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          var results = response.data;
          if (results.status === 0) {
            if (results.CartType === "Business") {
              this.business = true;
            }
            this.dashboardLoader = false;
            this.users = results;
          }
        })
        .catch(() => {
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        });
    },
    // hide error message
    hideErrorMessage() {
      (this.errorMessage = ""), (this.errorModal = false);
    },
    //scroll top
    scrollToTop() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
    //hide menu mobile when page loaded
    hideMenu() {
      EventBus.$emit("MOBILE_MENU_HIDE");
    },
    cardInfoList() {
      var cardHolderInfo = this.$auth.getCardInfo();
      this.lastName = cardHolderInfo.lastName;
      this.firstName = cardHolderInfo.firstName;
    },
  },
  created() {
    this.fetchData();
    this.hideMenu();
    this.cardInfoList();
  },
};
</script>

<style>
#service {
  margin-top: 30px;
}

.service-board {
  width: 100%;
  padding: 40px;
  /* box-shadow: 0px 2px 8px 0 rgba(0, 0, 0, 0.2); */
  background: #fff;
}

.text-body {
  margin: 0;
  padding: 0 40px;
  margin-top: 20px;
}

.text-body h2 {
  text-align: center;
  font-size: 18px;
  padding-bottom: 10px;
}

.text-body p {
  text-align: justify;
}

.footer-text {
  margin: 0;
  padding: 0;
  padding-left: 40px;
}

.footer-text p {
  margin: 0;
  padding: 0;
  padding-bottom: 5px;
}

.footer-text i {
  color: #32cd32;
}

.imgDev {
  position: absolute;
  top: 0;
  left: 120px;
}

.imgDev img {
  height: 150px;
}

.between {
  display: flex;
  justify-content: space-between;
}

.padding {
  padding: 0;
}
</style>
